<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { authStore } from '../authStore';

  let name = '';
  let email = '';
  let phoneCountry = '+852'; // Default HK
  let phoneNumber = '';
  let message = '';
  
  let isLoading = false;
  let success = false;
  let error = '';
  let currentUser = null;

  authStore.subscribe(value => {
    currentUser = value.user;
    // Pre-fill name if logged in
    if (currentUser && !name) {
        name = currentUser.name || '';
        // Email is often in idTokenClaims depending on provider setup
        email = currentUser.username || ''; 
    }
  });

  async function handleSubmit() {
    if (!name || !email || !message) {
        error = "Name, Email, and Message are required.";
        return;
    }

    isLoading = true;
    error = '';
    success = false;

    const payload = {
        senderName: name,
        email,
        phoneCountry,
        phoneNumber,
        message,
        // If logged in, attach ID
        userId: currentUser ? currentUser.idTokenClaims.oid : ""
    };

    try {
        const res = await fetch(getApiUrl('/contact'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        if (!res.ok) throw new Error("Failed to send message.");
        
        success = true;
        message = ''; // Clear message body only, keep contact info
    } catch(e) {
        error = e.message;
    } finally {
        isLoading = false;
    }
  }
</script>

<div class="contact-container">
    <h2>Contact Us</h2>
    <p>Have a question or feedback? Send us a message!</p>

    {#if success}
        <div class="success-card">
            <h3>Message Sent!</h3>
            <p>Thank you for contacting us. We will get back to you shortly.</p>
            <button on:click={() => success = false}>Send Another</button>
        </div>
    {:else}
        <form on:submit|preventDefault={handleSubmit}>
            <div class="form-group">
                <label for="name">Name *</label>
                <input type="text" id="name" bind:value={name} required />
            </div>

            <div class="form-group">
                <label for="email">Email *</label>
                <input type="email" id="email" bind:value={email} required />
            </div>

            <div class="form-group">
                <label for="phone">Phone Number</label>
                <div class="phone-row">
                    <select bind:value={phoneCountry} class="country-select">
                        <option value="+852">🇭🇰 +852</option>
                        <option value="+44">🇬🇧 +44</option>
                        <option value="+81">🇯🇵 +81</option>
                        <option value="+1">🇺🇸 +1</option>
                    </select>
                    <input type="tel" id="phone" bind:value={phoneNumber} placeholder="1234 5678" />
                </div>
            </div>

            <div class="form-group">
                <label for="message">Message *</label>
                <textarea id="message" rows="5" bind:value={message} required></textarea>
            </div>

            {#if error} <p class="error">{error}</p> {/if}

            <button type="submit" disabled={isLoading}>
                {isLoading ? 'Sending...' : 'Send Message'}
            </button>
        </form>
    {/if}
</div>

<style>
    .contact-container { max-width: 600px; margin: 2rem auto; padding: 2rem; background: #fff; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
    h2 { margin-top: 0; color: #0056b3; }
    .form-group { margin-bottom: 1rem; text-align: left; }
    label { display: block; margin-bottom: 0.5rem; font-weight: 500; }
    input, textarea, select { width: 100%; padding: 0.75rem; border: 1px solid #ccc; border-radius: 4px; font-size: 1rem; box-sizing: border-box; }
    
    .phone-row { display: flex; gap: 0.5rem; }
    .country-select { width: 120px; flex-shrink: 0; }
    
    button { width: 100%; padding: 0.75rem; background-color: #007bff; color: white; border: none; border-radius: 4px; font-size: 1.1rem; cursor: pointer; margin-top: 1rem; }
    button:disabled { background-color: #aaa; }
    
    .success-card { text-align: center; background: #e8f5e9; padding: 2rem; border-radius: 8px; color: #2e7d32; }
    .error { color: red; text-align: center; font-weight: bold; }
</style>